export default "__VITE_ASSET__PM9Q0nju__"